export const GET_COMMANDE_PACKS_RENTAL = "GET_COMMANDE_PACKS_RENTAL"
export const GET_UNIQUE_COMMANDE_PACK_RENTAL = "GET_UNIQUE_COMMANDE_PACK_RENTAL"
export const UPDATE_USER_PACK_RENTAL = "UPDATE_USER_PACK_RENTAL"